<div class="wrapper__contentComponent--expediente container my-5">
  <div class="d-flex justify-content-between align-items-center mb-5">
    <h2>Edición de encuenta de Justino</h2>
    <button
      id="crearPlantilla"
      class="btn-govco fill-btn-govco hvr-shrink ms-2"
      (click)="crearPlantilla()">
      <span class="govco-svg govco-plus-circle me-2"></span>
      Crear plantilla
    </button>
  </div>
  <!-- Formulario de creación de plantilla -->
  <div *ngIf="questionSets.length > 0; else noData">
    <div class="box mb-3">
      <form [formGroup]="questionForm" (ngSubmit)="addQuestion()">
        <h3>Plantilla</h3>
        <p>Por favor seleccione la plantilla a editar.</p>
        <select formControlName="set" (change)="onSetChange()">
          <option *ngFor="let set of questionSets" [value]="set">
            {{ set }}
          </option>
        </select>
        <h3>Pregunta</h3>
        <label>Enunicado</label>
        <p>Por favor ingrese el enunciado de la pregunta.</p>
        <textarea formControlName="description" rows="3"></textarea>

        <label>Estado</label>
        <p>
          Para activar o desactivar la pregunta seleccione o deseleccione el
          control.
        </p>
        <input formControlName="state" type="checkbox" />

        <label>Opciones</label>
        <p>
          A continuación, podrá usted editar las opciones de respuesta de la
          pregunta.
        </p>
        <div formArrayName="options">
          <div
            *ngFor="let option of options.controls; let i = index"
            class="box mb-3">
            <label>Opción {{ i + 1 }}</label>
            <p>Por favor ingrese la opción de respuesta.</p>
            <textarea
              [formControlName]="i"
              type="text"
              rows="3"
              class="mb-3 w-100"></textarea>
            <button
              type="button"
              (click)="removeOption(i)"
              class="btn-govco hvr-shrink">
              Eliminar
            </button>
          </div>
          <button
            type="button"
            (click)="addOption()"
            class="btn-govco outline-btn-govco hvr-shrink">
            Adicionar opción
          </button>
        </div>

        <button type="submit" class="btn-govco fill-btn-govco hvr-shrink">
          {{ editingIndex !== null ? 'Actualizar' : 'Adicionar' }} pregunta
        </button>
      </form>
      <!-- Validation Error Messages -->
      <div *ngFor="let field of formFields" class="col-md-{{ field.width }}">
        <div *ngIf="getErrorMessage(field.name)" class="text-danger">
          {{ getErrorMessage(field.name) }}
        </div>
      </div>
    </div>
    <div class="box">
      <h3>Lista de preguntas</h3>
      <ul>
        <li *ngFor="let question of questions; let i = index">
          <strong>[{{ question.set }}] {{ question.description }}</strong> -
          {{ question.state ? 'Activo' : 'Inactivo' }}
          <ul>
            <li *ngFor="let option of question.options">{{ option }}</li>
          </ul>
          <div class="d-flex gap-2 mt-3">
            <button (click)="editQuestion(i)" class="btn-govco hvr-shrink me-2">
              Editar
            </button>
            <button
              (click)="deleteQuestion(i)"
              class="btn-govco fill-btn-govco hvr-shrink">
              Eliminar
            </button>
          </div>
        </li>
      </ul>
    </div>
    <div class="box mt-3 d-flex justify-content-center">
      <button
        (click)="saveQuestions()"
        class="btn-govco fill-btn-govco hvr-shrink">
        Guardar cambios
      </button>
    </div>
  </div>
  <!-- Plantilla para mostrar mensaje si no hay datos -->
  <ng-template #noData>
    <div class="no-data-container">
      <p>No se han definido plantillas.</p>
    </div>
  </ng-template>
</div>
<!-- Modal para la creación de plantillas -->
<app-modal-nom-des
  [conDescripcion]="conDescripcion"
  [elements]="questionSets"
  (ndEmitter)="registrarPlantilla($event)">
</app-modal-nom-des>
